import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=b41ba47a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=b41ba47a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41ba47a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b41ba47a')) {
      api.createRecord('b41ba47a', component.options)
    } else {
      api.reload('b41ba47a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=b41ba47a&scoped=true&", function () {
      api.rerender('b41ba47a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2F49R00KfE3Gz/JS/comp/GuestBox.vue"
export default component.exports